import {
  TripLegStatus,
  TripLegStatusBC,
} from '../data/models/trip-leg-status.model';

const tripLegStatusToBCMap: Record<TripLegStatus, TripLegStatusBC> = {
  [TripLegStatus.Draft]: TripLegStatusBC.Draft,
  [TripLegStatus.OnHold]: TripLegStatusBC.OnHold,
  [TripLegStatus.Open]: TripLegStatusBC.Open,
  [TripLegStatus.Offered]: TripLegStatusBC.Offered,
  [TripLegStatus.Accepted]: TripLegStatusBC.Accepted,
  [TripLegStatus.Confirmed]: TripLegStatusBC.Confirmed,
  [TripLegStatus.Onsite]: TripLegStatusBC.Onsite,
  [TripLegStatus.Onboard]: TripLegStatusBC.Onboard,
  [TripLegStatus.Canceled]: TripLegStatusBC.Canceled,
  [TripLegStatus.NoLoad]: TripLegStatusBC.NoLoad,
  [TripLegStatus.Completed]: TripLegStatusBC.Completed,
  [TripLegStatus.Denied]: TripLegStatusBC.Denied,
  [TripLegStatus.Abandoned]: TripLegStatusBC.Abandoned,
  [TripLegStatus.Void]: TripLegStatusBC.Void,
  [TripLegStatus.InTransit]: TripLegStatusBC.InTransit,
  [TripLegStatus.CanceledLate]: TripLegStatusBC.CanceledLate,
  [TripLegStatus.Dropoff]: TripLegStatusBC.Dropoff,
  // NOTE: needed for RC-2141
  // Mapping to CanceledLate as there is no direct equivalent BC (needed for RC-2141)
  // not actually used in the app since we don't allow status updates to TripLegAppointmentTimePassed,
  // but included here to make TS happy
  [TripLegStatus.TripLegAppointmentTimePassed]: TripLegStatusBC.CanceledLate,
};

const tripLegStatusBCToStatusMap: Partial<
  Record<TripLegStatusBC, TripLegStatus>
> = {
  [TripLegStatusBC.Draft]: TripLegStatus.Draft,
  [TripLegStatusBC.OnHold]: TripLegStatus.OnHold,
  [TripLegStatusBC.Open]: TripLegStatus.Open,
  [TripLegStatusBC.Offered]: TripLegStatus.Offered,
  [TripLegStatusBC.Accepted]: TripLegStatus.Accepted,
  [TripLegStatusBC.Confirmed]: TripLegStatus.Confirmed,
  [TripLegStatusBC.Onsite]: TripLegStatus.Onsite,
  [TripLegStatusBC.Onboard]: TripLegStatus.Onboard,
  [TripLegStatusBC.Canceled]: TripLegStatus.Canceled,
  [TripLegStatusBC.NoLoad]: TripLegStatus.NoLoad,
  [TripLegStatusBC.Completed]: TripLegStatus.Completed,
  [TripLegStatusBC.Denied]: TripLegStatus.Denied,
  [TripLegStatusBC.Abandoned]: TripLegStatus.Abandoned,
  [TripLegStatusBC.Void]: TripLegStatus.Void,
  [TripLegStatusBC.InTransit]: TripLegStatus.InTransit,
  [TripLegStatusBC.CanceledLate]: TripLegStatus.CanceledLate,
  [TripLegStatusBC.Dropoff]: TripLegStatus.Dropoff,
};

export { tripLegStatusToBCMap, tripLegStatusBCToStatusMap };
